import { useEffect, useState } from 'react'
import { Box, Typography, Paper } from '@mui/material'
import I18n from 'i18n-js'
import { Icons } from '../../utils'
import { InputForm } from '..'
import useStyles from './style'

const AnnotationTranslate = ({ translation, data, setData, id }) => {
  const [questionTranslation, setQuestionTranslation] = useState(
    data[translation.locale]?.annotations?.[id]
      ? data[translation.locale]?.annotations[id]
      : { recomendation: '', interpretation: '' }
  )

  const handleChange = (e) => {
    setQuestionTranslation({
      ...questionTranslation,
      [e.target.name]: e.target.value,
    })
  }
  useEffect(() => {
    setQuestionTranslation(
      data[translation.locale]?.annotations?.[id]
        ? data[translation.locale]?.annotations[id]
        : { recomendation: '', interpretation: '' }
    )
  }, [id])

  useEffect(() => {
    if (data[translation.locale]) {
      setData({
        ...data,
        [translation.locale]: {
          ...data[translation.locale],
          annotations: {
            ...data[translation.locale].annotations,
            [id]: questionTranslation,
          },
        },
      })
    } else {
      data[translation.locale] = {
        name: '',
        description: '',
        annotations: { [id]: questionTranslation },
      }
    }
  }, [questionTranslation])
  const classes = useStyles()
  return (
    <Box className={classes.container}>
      <Box className={classes.labelContainer}>
        {Icons(translation.locale)}
        <Typography
          className={classes.label}
          variant="caption"
          color="textPrimary"
        >
          {I18n.t(translation.name)}
        </Typography>
      </Box>

      <Box className={classes.questionContainer}>
        <Paper className={classes.card}>
          <InputForm
            label={I18n.t('cruds.indicators.create.interpretation')}
            name="interpretation"
            variant="outlined"
            color="secondary"
            // size="small"
            rows={4}
            withMaxLength={false}
            value={questionTranslation.interpretation || ''}
            className={classes.textArea}
            onChange={handleChange}
            multiline
          />
          <InputForm
            variant="outlined"
            // size="small"
            name="recomendation"
            onChange={handleChange}
            value={questionTranslation.recomendation || ''}
            label={I18n.t('cruds.indicators.create.recomendationLabel')}
            color="secondary"
            className={classes.textArea}
            rows={4}
            withMaxLength={false}
            multiline
          />
        </Paper>
      </Box>
    </Box>
  )
}

export default AnnotationTranslate
